import Parse from 'html-react-parser';

function BMP20175(props) {
    let svgCode =
    `<svg width="57" height="24" viewBox="0 0 57 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    ${props.fontFace}
    </style>
        <rect x="1.5" y="1.5" width="54" height="21" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="14" font-weight="${props.fontExtras.weight}" letter-spacing="${props.fontExtras.space}"><tspan x="21.2445" y="16.7852">ENV 1</tspan></text>
        <line x1="12" y1="5" x2="12" y2="17" stroke="white" stroke-width="2"/>
        <line x1="18" y1="12" x2="6" y2="12" stroke="white" stroke-width="2"/>
        <path d="M12 20L8.5359 16.25L15.4641 16.25L12 20Z" fill="white"/>
        <path d="M12 4L15.4641 7.75L8.5359 7.75L12 4Z" fill="white"/>
        <path d="M4 12L7.75 8.5359L7.75 15.4641L4 12Z" fill="white"/>
        <path d="M20 12L16.25 15.4641L16.25 8.5359L20 12Z" fill="white"/>
    </svg>`

    props.svgReturn(16, svgCode, "bmp00175", 57, 24);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20175;